import { useEffect } from 'react'
import useControlledTableProperty from '../Utils/useControlledTableProperty'

const useColumnSizing = ({table, defaultColumnSizing, onColumnSizeChange}) => {
  const [columnSizing, setColumnSizing] = useControlledTableProperty({
    initialValue: {},
    controlledValue: defaultColumnSizing,
    name: 'columnSizing',
    onChangeFn: onColumnSizeChange
  })

  useEffect(() => {
    table?.setColumnSizing(columnSizing || {})
  }, [columnSizing, table?.setColumnSizing])

  return {
    columnSizing,
    setColumnSizing
  }
}

export default useColumnSizing